import React, { Component } from 'react';
import './TransomConfigurator.css';
import { ResizeSensor } from 'css-element-queries';

class TransomConfigurator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scale: 1
        };
        this.sensor = null;

        this.container = React.createRef();
        this.updateDimensions = this.updateDimensions.bind(this);
        this.multiplyColor = this.multiplyColor.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.updateDimensions();
    }

    componentDidMount() {
        this.updateDimensions();
        this.sensor = new ResizeSensor(this.container.current, this.updateDimensions);
    }

    componentWillUnmount() {
        if(this.sensor !== null){
            this.sensor.detach();
        }
    }

    updateDimensions() {
        if (this.container.current !== null) {
            this.setState({
                scale: this.container.current.clientWidth / 1000
            });
        }
    }

    multiplyColor(color) {
        if (this.props.colorMultiplier) {
            var colorValue = parseInt(color.replace("#", ""), 16);

            var red = (colorValue >> 16) & 0xFF;
            var green = (colorValue >> 8) & 0xFF;
            var blue = colorValue & 0xFF;

            red *= this.props.colorMultiplier;
            green *= this.props.colorMultiplier;
            blue *= this.props.colorMultiplier;

            colorValue = Math.min(255, Math.round(blue));
            colorValue += Math.min(255, Math.round(green)) << 8;
            colorValue += Math.min(255, Math.round(red)) << 16;

            return "#" + colorValue.toString(16);
        } else {
            return color;
        }
    }

    render() {
        let styles = {
            width: this.props.transomSize.width,
            height: this.props.transomSize.height,
            transform: 'scale(' + (this.state.scale) + ') matrix3d(' + this.props.transform.join() + ')'
        };

        let nameStyles = {
            fontFamily: this.props.name.font.value,
            fontSize: this.props.name.size.value,
            color: this.multiplyColor(this.props.name.color.value),
            transform: 'translate(' + this.props.name.horizontalOffset + 'px, ' + this.props.name.verticalOffset + 'px)'
        };

        let portStyles = {
            fontFamily: this.props.port.font.value,
            fontSize: this.props.port.size.value,
            color: this.multiplyColor(this.props.port.color.value),
            transform: 'translate(' + this.props.port.horizontalOffset + 'px, ' + this.props.port.verticalOffset + 'px)'
        };

        return (
            <div ref={this.container} className="transom">
                {this.props.children}

                <div style={styles} className="transom-editor">
                    <h1 style={nameStyles}>{this.props.name.value}</h1>
                    <h1 style={portStyles}>{this.props.port.value}</h1>
                </div>
            </div>
        );
    }
}

export default TransomConfigurator;


// WEBPACK FOOTER //
// ./src/TransomConfigurator.js